// src/index.js
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import './index.css';
import 'leaflet/dist/leaflet.css';
import { BrowserRouter } from 'react-router-dom';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <Suspense fallback={<div>Loading translations...</div>}>
      <I18nextProvider i18n={i18n}>
        {/* BrowserRouter kullanacaksan App'i bunun içine al */}
        {/* <BrowserRouter> */}
          <App />
        {/* </BrowserRouter> */}
      </I18nextProvider>
    </Suspense>
  </React.StrictMode>
);

// ====================
// Aktifken Beacon Gönderimi (Time-on-Page)
// ====================
// HMR/yeniden yüklemede iki kere kurulmasını önlemek için guard:
if (!window.__TOB_INIT__) {
  window.__TOB_INIT__ = true;

  // 1) Oturum için benzersiz id
  const sessionId =
    (crypto && crypto.randomUUID && crypto.randomUUID()) ||
    Math.random().toString(36).slice(2);

  // 2) Ayarlar
  const idleMs = 30_000;   // 30 sn hareketsizlikte dur
  const pingMs = 15_000;   // 15 sn’de bir ping
  let activeMs = 0;
  let lastActive = Date.now();

  // 3) Kullanıcı aktif mi?
  function isActive() {
    return !document.hidden && document.hasFocus() && Date.now() - lastActive <= idleMs;
  }

  // 4) Aktivite olayları
  ['mousemove','mousedown','keydown','scroll','touchstart'].forEach(evt => {
    window.addEventListener(evt, () => (lastActive = Date.now()), { passive: true });
  });
  document.addEventListener('visibilitychange', () => (lastActive = Date.now()));
  window.addEventListener('focus', () => (lastActive = Date.now()));
  window.addEventListener('blur', () => (lastActive = Date.now()));

  // 5) Sayaç (her saniye)
  setInterval(() => {
    if (isActive()) activeMs += 1000;
  }, 1000);

  // 6) Ping gönder
  function sendBeacon(evt = 'hb') {
    if (evt === 'hb' && !isActive()) return;
    const url = `/tb?sid=${encodeURIComponent(sessionId)}&evt=${evt}&d=${activeMs}&p=${encodeURIComponent(window.location.pathname)}&ref=${encodeURIComponent(document.referrer || "")}`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url);
    } else {
      fetch(url, { method: 'POST', keepalive: true });
    }
  }

  // 7) Periyodik ping (yalnızca aktifken)
  setInterval(() => sendBeacon('hb'), pingMs);

  // 8) Sekme kapanışında final
  window.addEventListener('beforeunload', () => sendBeacon('final'));
  window.addEventListener('pagehide', () => sendBeacon('final'));
}
